import { isTask } from 'common-data-handling';
import { useMemo } from 'react';
import { useEventSchedule } from './useEventSchedule';

/**
 * Returns all tasks for a given event ID.
 * @param {number} eventId
 * @return {array}
 */
export function useTasks(eventId, { filter, orderBy } = {}) {
    const tasks = useEventSchedule(eventId, {
        filter: isTask,
    });

    return useMemo(() => {
        let result = tasks;

        if (filter) result = result.filter(filter);
        if (orderBy) result = sortBy(result, orderBy);

        return result;
    }, [tasks, filter, orderBy]);
}
